// Generated by Melange


const black = "#232837";

const asphaltDark = "#424e59";

const grayDefault = "#a7adb3";

const gray = "#e9eaec";

const grayLight = "#f2f3f5";

const grayMedium = "#818C96";

const grayPale = "#f6f7f9";

const white = "#ffffff";

const links = "#0f55ed";

const secondary = "#0fb8ed";

const success = "#4dac2c";

const warning = "#ffe600";

const alert = "#ed510f";

const transparent = "rgba(0,0,0,0)";

export {
  black,
  asphaltDark,
  grayDefault,
  gray,
  grayLight,
  grayMedium,
  grayPale,
  white,
  links,
  secondary,
  success,
  warning,
  alert,
  transparent,
}
/* No side effect */
